/*
*###############################################################################
*Module Name                   : UserGroupDetails.js                           #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W G Chathura Prabashwara                     #
*Date                          : Friday, Octomber 22nd 2021, 9:15:38 am        #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState, useEffect } from "react"
import { Row, Col, Label } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPSwitch from "framework/components/DPSwitch"
import ReactPaginate from 'react-paginate';


const UserGroupDetNew = ({
  DataRow,
  setarRow,
  table,
  Disable,
  currentPage,
  setCurrentPage,
  clearOnEdit
}) => {

  const [DataTable, setDataTable] = useState([])
  const [TempTable, setTempTable] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [searchByMenuname, setSearchByMenuname] = useState(true)
  const [access, setAccess] = useState(false)
  const [create, setCreate] = useState(false)
  const [modify, setModify] = useState(false)
  const [deletee, setDelete] = useState(false)
  const [process, setProcess] = useState(false)
  const [right, setRight] = useState(false)


  useEffect(() => {
    if (searchTerm === "") {
      setDataTable(DataRow)
      setTempTable(DataRow)
    } else {
      setTempTable(DataRow)
    }
 
  }, [DataRow])

  useEffect(() => {
    searchHandler("")
    setAccess(false)
    setCreate(false)
    setModify(false)
    setDelete(false)
    setProcess(false)
    setRight(false)
  }, [table])


  useEffect(() => {
    setSearchTerm("")
  }, [clearOnEdit])


  function handleSwitchChanges(e, values, index, letter) {
    const Table = [...TempTable]
    const change = values;
    const newValue = e;
    var oldValue = String(values.permi)
    var permissonSet = []

    for (let i = 0; i < oldValue.length; i++) {
      permissonSet.push(oldValue[i])
    }
    permissonSet = permissonSet.filter((item) => item != letter)

    if (e) {
      permissonSet.push(letter)
    } else {
      permissonSet.filter((item) => item != letter)
    }


    change.permi = permissonSet.sort().join("")
    var newStoles = [];

    for (var i = 0; i < Table.length; i++) {
      if (Table[i].id == index) {
        newStoles.push(change);
      } else {
        newStoles.push(Table[i]);
      }
    }

    setarRow(newStoles);

  }

  async function handleHeaderSwitches(value, letter) {
    const Table = [...TempTable]
    const modifiedTable = []
    for (let i = 0; i < DataTable.length; i++) {
      var oldrow = DataTable[i]
      var oldrowPermission = String(DataTable[i].permi)
      var oldShow = String(DataTable[i].show)

      var permissonSet = []

      for (let i = 0; i < oldrowPermission.length; i++) {
        permissonSet.push(oldrowPermission[i])
      }
      permissonSet = permissonSet.filter((item) => item != letter)

      if (value) {
        permissonSet.push(letter)
      } else {
        permissonSet.filter((item) => item != letter)
      }

      var newtable = []
      if (permissonSet.length != 0) {
        for (let i = 0; i < oldShow.length; i++) {
          var permisionLetter = permissonSet.find((item) => { return item == oldShow[i] })
          newtable.push(permisionLetter)

        }
      }

      oldrow.permi = newtable.sort().join("")

      modifiedTable.push(oldrow)
    }

    var newtable = []

    var difference = Table.filter(object1 => {
      return !modifiedTable.some(object2 => {
        return object1.id === object2.id;
      });
    });

    var combine = modifiedTable.concat(difference).sort((a, b) => a.id - b.id)

    setarRow(combine);

  }


  //search function
  const searchHandler = (searchTerm) => {

    setSearchTerm(searchTerm)
    setCurrentPage(1)

  }

  // const [currentPage, setCurrentPage] = useState(1)
  const [postsPerPage] = useState(10)

  const newDataTable = DataRow.filter((value) => {
    if (searchByMenuname) {
      return value.menunname.toLowerCase().includes(searchTerm.toLowerCase())
    } else {
      return value.menu.toLowerCase().includes(searchTerm.toLowerCase())
    }
  })

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = newDataTable.slice(indexOfFirstPost, indexOfLastPost)


  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };






  return (
    <React.Fragment>
      <Row style={{ display: "flex", justifyContent: "flex-end", marginBottom: "15px" }}>
        <Col sm={12} md={1} >
          <Label for="search">Search</Label>
        </Col>
        <Col sm={12} md={2} >
          <DPTextBoxforgrid
            label="Search"
            id="search_menu"
            placeholder={searchByMenuname ? "Search by Menu Name" : "Search by Menu Code"}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value)
              searchHandler(e.target.value)
            }}
            disabled={false}
          />
        </Col>
      </Row>

      <Row>
        <table className="custom-table table-bordered table-sm rounded table-no-border table-no-hover">
          <thead className='table-secondary'>
            <tr style={{ height: '40px' }}>
              <td style={{ textAlign: 'center' }}>Row</td>

              <td style={{ cursor: "pointer", width: '100px' }}
                onClick={() => {
                  setSearchByMenuname(false)
                  document.getElementById("search_menu").focus()
                }}>Menu Tag</td>

              <td style={{ cursor: "pointer" }}
                onClick={() => {
                  setSearchByMenuname(true)
                  document.getElementById("search_menu").focus()
                }}>Menu Name</td>

              <td style={{ width: '100px' }}>Permissions</td>

              <td style={{ textAlign: 'center', cursor: "pointer" }} onClick={() => {
                if (Disable == false) {
                  handleHeaderSwitches(!access, "A")
                  setAccess(!access)
                }
              }}>Access</td>

              <td style={{ textAlign: 'center', cursor: "pointer" }} onClick={() => {
                if (Disable == false) {
                  handleHeaderSwitches(!create, "C")
                  setCreate(!create)
                }
              }}>Create</td>

              <td style={{ textAlign: 'center', cursor: "pointer" }} onClick={() => {
                if (Disable == false) {
                  handleHeaderSwitches(!modify, "M")
                  setModify(!modify)
                }
              }}>Modify</td>

              <td style={{ textAlign: 'center', cursor: "pointer" }} onClick={() => {
                if (Disable == false) {
                  handleHeaderSwitches(!deletee, "D")
                  setDelete(!deletee)
                }
              }}>Delete</td>

              <td style={{ textAlign: 'center', cursor: "pointer" }} onClick={() => {
                if (Disable == false) {
                  handleHeaderSwitches(!process, "P")
                  setProcess(!process)
                }
              }}>Process</td>

              <td style={{ textAlign: 'center', cursor: "pointer" }} onClick={() => {
                if (Disable == false) {
                  handleHeaderSwitches(!right, "R")
                  setRight(!right)
                }
              }}>Print</td>

            </tr>
          </thead>
          <tbody>
            {currentPosts.map((item, index) => (
              <TableRow
                values={item}
                index={index}
                Disable={Disable}
                GroupCode={table.GroupCode}
                handleSwitchChanges={handleSwitchChanges}
              />
            ))}
          </tbody>
        </table>
      </Row>
      <Row className="mt-2">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          pageCount={Math.ceil(newDataTable.length / postsPerPage)}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          forcePage={currentPage - 1}
          renderOnZeroPageCount={null}
          activeClassName={'active'}
          activeLinkClassName={'page-link'}
          containerClassName={'pagination justify-content-center pagination-sm'}
        />
      </Row>


      {/* <Row style={{ marginBottom: '5px' }}>
        <Col sm={12} md={1} className="mb-12-sm w" style={{ width: '60px' }} >
          <Label>Row</Label>
        </Col>
        <Col sm={12} md={1} className="mb-12-sm" style={{ width: '150px' }}>
          <Label disabled={Disable} style={{ cursor: "pointer" }} onClick={() => {
            setSearchByMenuname(false)
            document.getElementById("search_menu").focus()
          }}>Menu Tag</Label>
        </Col>
        <Col sm={12} md={2} className="mb-12-sm">
          <Label disabled={Disable} style={{ cursor: "pointer" }} onClick={() => {
            setSearchByMenuname(true)
            document.getElementById("search_menu").focus()
          }}>Menu Name</Label>
        </Col>
        <Col sm={12} md={2} className="mb-12-sm" style={{ width: '105px' }}>
          <Label>Permissions</Label>
        </Col>
        <Col sm={12} md={1} className="mb-12-sm">
          <Label style={{ cursor: "pointer" }} onClick={() => {
            if (Disable == false) {
              handleHeaderSwitches(!access, "A")
              setAccess(!access)
            }
          }}>Access</Label>
        </Col>
        <Col sm={12} md={1} className="mb-12-sm">
          <Label style={{ cursor: "pointer" }} onClick={() => {
            if (Disable == false) {
              handleHeaderSwitches(!create, "C")
              setCreate(!create)
            }
          }}>Create</Label>
        </Col>
        <Col sm={12} md={1} className="mb-12-sm">
          <Label style={{ cursor: "pointer" }} onClick={() => {
            if (Disable == false) {
              handleHeaderSwitches(!modify, "M")
              setModify(!modify)
            }
          }}>Modify</Label>
        </Col>
        <Col sm={12} md={1} className="mb-12-sm">
          <Label style={{ cursor: "pointer" }} onClick={() => {
            if (Disable == false) {
              handleHeaderSwitches(!deletee, "D")
              setDelete(!deletee)
            }
          }}>Delete</Label>
        </Col>
        <Col sm={12} md={1} className="mb-12-sm">
          <Label style={{ cursor: "pointer" }} onClick={() => {
            if (Disable == false) {
              handleHeaderSwitches(!process, "P")
              setProcess(!process)
            }
          }}>Process</Label>
        </Col>
        <Col sm={12} md={1} className="mb-12-sm">
          <Label style={{ cursor: "pointer" }} onClick={() => {
            if (Disable == false) {
              handleHeaderSwitches(!right, "R")
              setRight(!right)
            }
          }}>Print</Label>
        </Col>
      </Row> */}
      {/* <Row  >
        <TableWithPagination DataTables={DataTable} handleSwitchChanges={handleSwitchChanges} table={table} Disable={Disable} />
      </Row> */}
    </React.Fragment>
  )
}
export default UserGroupDetNew


const TableRow = ({ values, index, Disable, GroupCode, handleSwitchChanges }) => {
  var show = String(values.show)
  var permi = String(values.permi)

  const [showAccess, setShowAccess] = useState(show.indexOf("A") > -1 ? true : false)
  const [showCreate, setShowCreate] = useState(show.indexOf("C") > -1 ? true : false)
  const [showModify, setShowModify] = useState(show.indexOf("M") > -1 ? true : false)
  const [showDelete, setShowDelete] = useState(show.indexOf("D") > -1 ? true : false)
  const [showProcess, setShowProcess] = useState(show.indexOf("P") > -1 ? true : false)
  const [showPrint, setShowPrint] = useState(show.indexOf("R") > -1 ? true : false)

  var [access, setAccess] = useState(permi.indexOf("A") > -1 ? true : false)
  var [create, setCreate] = useState(permi.indexOf("C") > -1 ? true : false)
  var [modify, setModify] = useState(permi.indexOf("M") > -1 ? true : false)
  var [delete1, setDele] = useState(permi.indexOf("D") > -1 ? true : false)
  var [process, setProcess] = useState(permi.indexOf("P") > -1 ? true : false)
  var [print, setPrint] = useState(permi.indexOf("R") > -1 ? true : false)

  useEffect(() => {
    setAccess(permi.indexOf("A") > -1 ? true : false)
    setCreate(permi.indexOf("C") > -1 ? true : false)
    setModify(permi.indexOf("M") > -1 ? true : false)
    setDele(permi.indexOf("D") > -1 ? true : false)
    setProcess(permi.indexOf("P") > -1 ? true : false)
    setPrint(permi.indexOf("R") > -1 ? true : false)

    setShowAccess(show.indexOf("A") > -1 ? true : false)
    setShowCreate(show.indexOf("C") > -1 ? true : false)
    setShowModify(show.indexOf("M") > -1 ? true : false)
    setShowDelete(show.indexOf("D") > -1 ? true : false)
    setShowProcess(show.indexOf("P") > -1 ? true : false)
    setShowPrint(show.indexOf("R") > -1 ? true : false)


  }, [permi, show])


  return (
    <tr>
      <td style={{ textAlign: 'center' }}>
        {values.id}
      </td>
      <td>
        <DPTextBoxforgrid
          textType="text"
          value={values.menu}
          disabled={true}
        />
      </td>
      <td>
        <DPTextBoxforgrid
          textType="text"
          value={values.menunname}
          disabled={true}
        />
      </td>
      <td>
        <DPTextBoxforgrid
          textType="text"
          value={values.permi}
          onChange={e => {
          }}
          disabled={true}
        />
      </td>
      <td style={{ textAlign: 'center' }}>
        {showAccess ?
          <DPSwitch
            checked={access}
            onChange={e => {
              setAccess(e)
              handleSwitchChanges(e, values, values.id, "A")
            }}
            disabled={Disable}
          /> : null}
      </td>
      <td style={{ textAlign: 'center' }}>
        {showCreate ?
          <DPSwitch
            checked={create}
            onChange={e => {
              setCreate(e)
              handleSwitchChanges(e, values, values.id, "C")
            }}
            disabled={Disable}
          /> : null}
      </td>
      <td style={{ textAlign: 'center' }}>
        {showModify ?
          <DPSwitch
            checked={modify}
            onChange={e => {
              setModify(e)
              handleSwitchChanges(e, values, values.id, "M")
            }}
            disabled={Disable}
          /> : null}
      </td>
      <td style={{ textAlign: 'center' }}>
        {showDelete ?
          <DPSwitch
            checked={delete1}
            onChange={e => {
              setDele(e)
              handleSwitchChanges(e, values, values.id, "D")
            }}
            disabled={Disable}
          /> : null}
      </td>
      <td style={{ textAlign: 'center' }}>
        {showProcess ?
          <DPSwitch
            checked={process}
            onChange={e => {
              setProcess(e)
              handleSwitchChanges(e, values, values.id, "P")
            }}
            disabled={Disable}
          /> : null}
      </td>
      <td style={{ textAlign: 'center' }}>
        {showPrint ?
          <DPSwitch
            checked={print}
            onChange={e => {
              setPrint(e)
              handleSwitchChanges(e, values, values.id, "R")
            }}
            disabled={Disable}
          /> : null}
      </td>
    </tr>
    // <React.Fragment>

    //   <Row key={index} style={{ marginBottom: '5px' }}>
    //     <Col sm={12} md={1} className="mb-12-sm w" style={{ width: '60px' }} >
    //       {values.id}
    //     </Col>
    //     <Col sm={12} md={1} className="mb-12-sm" style={{ width: '150px' }}>
    //       <DPTextBoxforgrid
    //         textType="text"
    //         value={values.menu}
    //         disabled={true}
    //       />
    //     </Col>
    //     <Col sm={12} md={2} className="mb-12-sm">
    //       <DPTextBoxforgrid
    //         textType="text"
    //         value={values.menunname}
    //         disabled={true}
    //       />
    //     </Col>
    //     <Col sm={12} md={2} className="mb-12-sm" style={{ width: '107px' }}>
    //       <DPTextBoxforgrid
    //         textType="text"
    //         value={values.permi}
    //         onChange={e => {
    //         }}
    //         disabled={true}
    //       />
    //     </Col>
    //     <Col sm={12} md={1} className="mb-12-sm">
    //       {showAccess ? <DPSwitch
    //         checked={access}
    //         onChange={e => {
    //           setAccess(e)
    //           handleSwitchChanges(e, values, values.id, "A")
    //         }}
    //         disabled={Disable}
    //       /> : null}
    //     </Col>
    //     <Col sm={12} md={1} className="mb-12-sm">
    //       {showCreate ? <DPSwitch
    //         checked={create}
    //         onChange={e => {
    //           setCreate(e)
    //           handleSwitchChanges(e, values, values.id, "C")
    //         }}
    //         disabled={Disable}
    //       /> : null}
    //     </Col>
    //     <Col sm={12} md={1} className="mb-12-sm">
    //       {showModify ? <DPSwitch
    //         checked={modify}
    //         onChange={e => {
    //           setModify(e)
    //           handleSwitchChanges(e, values, values.id, "M")
    //         }}
    //         disabled={Disable}
    //       /> : null}
    //     </Col>
    //     <Col sm={12} md={1} className="mb-12-sm">
    //       {showDelete ? <DPSwitch
    //         checked={delete1}
    //         onChange={e => {
    //           setDele(e)
    //           handleSwitchChanges(e, values, values.id, "D")
    //         }}
    //         disabled={Disable}
    //       /> : null}
    //     </Col>
    //     <Col sm={12} md={1} className="mb-12-sm">
    //       {showProcess ? <DPSwitch
    //         checked={process}
    //         onChange={e => {
    //           setProcess(e)
    //           handleSwitchChanges(e, values, values.id, "P")
    //         }}
    //         disabled={Disable}
    //       /> : null}
    //     </Col>
    //     <Col sm={12} md={1} className="mb-12-sm">
    //       {showPrint ? <DPSwitch
    //         checked={print}
    //         onChange={e => {
    //           setPrint(e)
    //           handleSwitchChanges(e, values, values.id, "R")
    //         }}
    //         disabled={Disable}
    //       /> : null}
    //     </Col>
    //   </Row>

    // </React.Fragment>
  )

}


//componet with pagination
const TableWithPagination = ({ DataTables, handleSwitchChanges, table, Disable }) => {


  useEffect(() => {
    setDataTable(DataTables)
  }, [DataTables])


  useEffect(() => {
    setCurrentPage(1)
  }, [table])

  const [DataTable, setDataTable] = useState(DataTables)
  const [currentPage, setCurrentPage] = useState(1)
  const [postsPerPage] = useState(10)
  const [searchTerm, setSearchTerm] = useState("")

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataTable.slice(indexOfFirstPost, indexOfLastPost)


  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  return (
    <React.Fragment>
      <Row>
        <Col md="12">
          {currentPosts.map((values, index) => {
            return (
              <TableRow
                DataTables={DataTables}
                values={values}
                index={index}
                handleSwitchChanges={handleSwitchChanges}
                Disable={Disable}
              />
            )
          })
          }
        </Col>
      </Row>
      <Row>
        <Col md="12">

        </Col>
      </Row>

    </React.Fragment>
  )
}

//fiter object array
